import { render, staticRenderFns } from "./PanelTabBarV2026.vue?vue&type=template&id=290d668e&scoped=true"
import script from "./PanelTabBarV2026.vue?vue&type=script&lang=js"
export * from "./PanelTabBarV2026.vue?vue&type=script&lang=js"
import style0 from "./PanelTabBarV2026.vue?vue&type=style&index=0&id=290d668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d668e",
  null
  
)

export default component.exports